import { render, staticRenderFns } from "./priceSelecter.vue?vue&type=template&id=946865d2&scoped=true"
import script from "./priceSelecter.vue?vue&type=script&lang=js"
export * from "./priceSelecter.vue?vue&type=script&lang=js"
import style0 from "./priceSelecter.vue?vue&type=style&index=0&id=946865d2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946865d2",
  null
  
)

export default component.exports